import { render, staticRenderFns } from "./Button2FASetup.vue?vue&type=template&id=502ff9b0&"
import script from "./Button2FASetup.vue?vue&type=script&lang=js&"
export * from "./Button2FASetup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports